import {FuncKeywordDefinition} from "ajv";

const def: FuncKeywordDefinition = {
    keyword: "nfDisabled",
    schemaType: "object",
    valid: true
};

export default def;
